import Slider from 'react-slick';
import { useEffect, useState } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const InstagramEmbed = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const script = document.createElement('script');
    script.setAttribute('src', 'https://www.instagram.com/embed.js');
    script.async = true;
    script.onload = () => {
      if (window.instgrm) {
        window.instgrm.Embeds.process();
      }
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, [currentSlide]);

  const settings = {
    dots: false,
    infinite: true,
    centerMode: true,
    centerPadding: '0px',
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 600,
    autoplaySpeed: 6000,
    pauseOnHover: true,
    swipeToSlide: true,
    touchMove: true,
    beforeChange: (_, next) => setCurrentSlide(next),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
    ],
  };

  const posts = [
    'https://www.instagram.com/p/DJReRz5IOay/',
    'https://www.instagram.com/p/DHgZCTXNdYG/',
    'https://www.instagram.com/p/DHn6EFfNO_7/',
    'https://www.instagram.com/p/DHbAyeNNcj9/',
    'https://www.instagram.com/p/DHgZCTXNdYG/',
    'https://www.instagram.com/p/DDPQdQtIBXH/',
  ];

  return (
    <div className="mt-12 w-full px-4 py-8 max-w-7xl mx-auto">
      <h2 className="text-white text-2xl font-bold mb-4">Neueste Nachrichten</h2>
      <p className="text-yellow-500 text-lg mb-6">
        Folgen Sie uns auf Instagram und Facebook.
      </p>

      <div
        className="[&_.slick-track]:overflow-visible [&_.slick-slide]:overflow-visible"
        style={{
          touchAction: 'pan-y pinch-zoom',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        <Slider {...settings}>
          {posts.map((url, index) => {
            const isCenter = index === currentSlide;

            return (
              <div key={index} className="px-2 touch-pan-y">
                <div
                  className={`
                    transition-all duration-500 ease-in-out
                    ${isCenter ? 'scale-105 z-30' : 'scale-90 z-10'}
                    relative mx-auto w-[300px] h-[480px]
                    rounded-2xl overflow-hidden shadow-lg bg-white
                  `}
                >
                  <blockquote
                    className="instagram-media w-full h-full"
                    data-instgrm-permalink={url}
                    data-instgrm-version="14"
                  />
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default InstagramEmbed;
